import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Row, Col, Typography, Button, Divider, Form, Input } from 'antd';
import { ClockCircleTwoTone, CalendarOutlined } from '@ant-design/icons';
import { ReactComponent as PlayCircleSvg } from '../../../../assets/icons/knowledge-bank/play-circle.svg';

import HeaderBack from '../../../../components/mobile/HeaderBack';

const { Search } = Input;
const { Title, Paragraph } = Typography;

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
}

const data = [
  {
    title: 'Video 01',
    description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry...',
    time: '10 mins 15 s',
    label: 'Added yestrday',
    url: '/knowledge-bank/detail/video/detail'
  },
  {
    title: 'Video 02',
    description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry...',
    time: '10 mins 15 s',
    label: 'Added on 12/10/2021',
    url: '/knowledge-bank/detail/video/detail'
  },
  {
    title: 'Video 03',
    description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry...',
    time: '5 mins 15 s',
    label: 'Added on 12/10/2021',
    url: '/knowledge-bank/detail/video/detail'
  },
  {
    title: 'Video 04',
    description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry...',
    time: '12 mins 11 s',
    label: 'Added on 12/10/2021',
    url: '/knowledge-bank/detail/video/detail'
  }
];

function MobileVideoHomeScreen() {
  const { t } = useTranslation(['knowledge-bank', 'common']);
  const history = useHistory();

  const onBack = () => {
    history.push('/knowledge-bank/detail')
  }

  const onReadMore = (url) => {
    history.push(url)
  }

  const VideoItem = ({item}) => {
    return (
      <Col xs={24}>
        <Box style={styles.box}>
          <Box style={styles.boxVideo}>
            <PlayCircleSvg />
          </Box>
          <Box paddingY={20} paddingX={24}>
            <Title level={4} style={styles.itemTitle} onClick={() => onReadMore(item.url)}>
              {item.title}
            </Title>
            <Paragraph style={styles.itemDescription}>
              {item.description}
            </Paragraph>
          </Box>
          <Box paddingY={8} paddingX={8} style={styles.boxFooter}>
            <Row justify="center">
              <Col xs={10}>
                <Row align="middle" justify="center">
                  <ClockCircleTwoTone style={{ marginRight: 10 }}/>
                  <Title level={4} style={styles.itemTime}>
                    {item.time}
                  </Title>
                </Row>
              </Col>
              <Col xs={2} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <hr style={styles.vertical} />
              </Col>
              <Col xs={11}>
                <Row align="middle" justify="center">
                  <CalendarOutlined style={{ marginRight: 10 }} />
                  <Title level={4} style={styles.itemLabel}>
                    {item.label}
                  </Title>
                </Row>
              </Col>
            </Row>
          </Box>
        </Box>
      </Col>
    )
  }

  return (
    <>
      <HeaderBack
        onBack={onBack}
        text={t('knowledge-bank:videos.backTitle')}
        title={t('knowledge-bank:videos.title')}
        subtitle={t('knowledge-bank:videos.subtitle')}
      />
      <Divider />
      <Box marginTop={26} marginBottom={26}>
        <Form.Item
          style={{ width: '100%', padding: '3%' }}
          formItemLayout={formItemLayout}
        >
          <Search placeholder={t('knowledge-bank:videos.search')} />
        </Form.Item>
      </Box>
      <Row>
        {data.map((item) => <VideoItem item={item} />)}
      </Row>
    </>
  );
}

const styles = {
  box: {
    background: "#FFFFFF", 
    border: "1px solid #D9D9D9", 
    boxSizing: "border-box", 
    borderRadius: "4px",
    marginBottom: 25
  },
  boxVideo: {
    width: "100%", 
    height: "200px",
    background: "#C4C4C4",
    position: "relative",
    display: "flex", 
    justifyContent: "center", 
    alignItems: "center"
  },
  boxFooter: {
    borderTop: "1px solid #D9D9D9", 
  },
  itemTitle: {
    fontWeight: "500", 
    fontSize: "16px", 
    lineHeight: "24px", 
    color: "#262626",
    marginBottom: 8
  },
  itemDescription: {
    fontWeight: "300", 
    fontSize: "14px", 
    lineHeight: "22px", 
    color: "#8C8C8C"
  },
  itemTime: {
    fontWeight: "500", 
    fontSize: "12px", 
    lineHeight: "19px", 
    textAlign: "center", 
    letterSpacing: "-0.04em", 
    color: "#15A9E1",
    margin: 0
  },
  itemLabel: {
    fontWeight: "500", 
    fontSize: "12px", 
    lineHeight: "19px", 
    textAlign: "center", 
    letterSpacing: "-0.04em", 
    color: "#8C8C8C",
    margin: 0
  },
  vertical: {
    display: "inline",
    color: "rgba(217, 217, 217, 0.1)", 
    textAlign: "center", 
    width: "0px", 
    height: "100%"
  }
};

export default MobileVideoHomeScreen;
